import { useEffect, useState } from 'react'

export const useDebouncedBoolean = (value: boolean, delay: number) => {
  const [state, setState] = useState(value)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setState(value)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [delay, value])

  return state
}
